<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Administrar Denuncias</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row">
              <div class="col-3">
                <b>Periodo de Búsqueda: </b>
              </div>
            
            <div class="col-3"></div>
            <div class="col-3">
              <b>Texto de búsqueda: </b>
            </div>
            </div>
            <div class="row" v-on:keyup.enter="obtenerDenuncias">
              <div class="col-3">
                <input type="date" class="form-control" v-model="filtroDenuncias.fechaInicialPeriodo" />
              </div>
              <div class="col-3">
                <input type="date" class="form-control" v-model="filtroDenuncias.fechaFinalPeriodo" />
              </div>
              <div class="col-3">
                <input type="text" class="form-control" v-model="filtroDenuncias.textoDeBusqueda" />
              </div>
              <div class="col-3">
                <input type="button" class="form-control" value="Buscar" @click="obtenerDenuncias" />
              </div>
            </div>
            <div class="row new-row">
              <div class="col-12">
                <table
                  class="table table-striped table-light table-hover"
                  id="tablaFaltasAdministrativas"
                >
                  <thead class="thead-green">
                    <tr>
                      <th class="col-1">No. FA</th>
                      <th class="col-2">Consecutivo</th>
                      <th class="col-2">Involucrados</th>
                      <th class="col-2">Observaciones</th>
                      <th class="col-2">Fecha Límite</th>
                      <th class="col-2">Calificación/Fecha de Devolucion</th>
                      <th class="col-1">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr
                      v-for="denuncia in denuncias"
                      v-bind:key="denuncia.denunciaId"
                    >
                      <td>{{ denuncia.denunciaId }}</td>
                      <td>{{ denuncia.consecutivo }}</td>
                      <td>
                        <b>Denunciante:</b><br />
                        <span v-for="persona in denuncia.personas.filter(p=> p.tipoPersonaId === 1)" v-bind:key="persona.personaId">
                          {{persona.nombreCompleto()}}<br/>
                        </span>
                        <hr />
                        <b>Presunto Responsable:</b><br />
                        <span v-for="persona in denuncia.personas.filter(p=> p.tipoPersonaId === 2)" v-bind:key="persona.personaId">
                          {{persona.nombreCompleto()}}<br/>
                        </span>
                      </td>
                      <td>
                        {{denuncia.observaciones}}
                      </td>
                      <td>
                        {{
                          anadirDias(
                            new Date(denuncia.fechaDeRecepcion),
                            30
                          ).toLocaleDateString("es-MX", opcionesFechaLocal)
                        }}
                      </td>
                      <td>
                        {{denuncia.tipoDeCalificacion? denuncia.tipoDeCalificacion.nombre : "No Calificada" }}<br />
                        {{denuncia.fechaDeInforme? new Date(denuncia.fechaDeInforme).toLocaleDateString("es-MX", opcionesFechaLocal) : "" }}
                      </td>
                      <td>
                        <i class="fas fa-edit fa-lg" title="Editar Denuncia" @click="editarDenuncia(denuncia.denunciaId)"/>
                        <i class="fas fa-trash fa-lg" title="Eliminar Denuncia" @click="eliminarDenuncia(denuncia.denunciaId)" />
                      </td>
                    </tr>
                    <tr v-if="denuncias.length == 0">
                      <td colspan="7">No se encontraron denuncias.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import { Denuncia } from "@/components/SIFA/Comun/Modelos/Denuncia.js";
import { FiltroDenuncias } from "@/components/SIFA/Comun/Modelos/Filtros/FiltroDenuncias.js";
export default {
  data() {
    return {
      filtroDenuncias: new FiltroDenuncias(),
      denuncias: [],
      opcionesFechaLocal: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
      }
    };
  },
  props: {},
  components: {},
  methods: {
    obtenerDenuncias: function() {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        filtroDenuncias: this.filtroDenuncias
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.ObtenerDenuncias,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            this.denuncias = response.data.denuncias.map(denuncia => {
              let nuevaDenuncia = new Denuncia();
              nuevaDenuncia.constructorObjeto(denuncia);
              return nuevaDenuncia;
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    eliminarDenuncia: function(denunciaId) {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        DenunciaId: denunciaId
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.EliminarDenuncia,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            this.obtenerDenuncias();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    editarDenuncia(denunciaId) {
        //console.log(quejaAdministrativaId)
        this.$router.push({ name: 'EdicionDeDenuncia', params: { prop_denunciaId: denunciaId } })
      },
    anadirDias(date, dias) {
      let resultado = new Date(date);
      resultado.setDate(resultado.getDate() + dias);
      return resultado;
    },
    
  },
  mounted: function mounted() {
    this.obtenerDenuncias();
    this.filtroDenuncias.cargarDatosParaFormulario(["administrar-denuncias"]);
  },
  computed: {}
};
</script>

<style scoped>


b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.fas {
  cursor: pointer;
}

.tab {
  overflow: hidden;
  padding-left: 15px;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: #45454c;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
  color: whitesmoke;
  border-right: 1px solid #ccc;
  width: 20vw;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
  color: #000;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: #ccc;
  color: #000;
  font-weight: bolder;
}

.bigtextarea {
  height: 100px;
}

.thead-green{
    background-color: var(--verde-pj-100);
    }
</style>



// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/AdministrarDenuncias/AdministrarDenuncias.vue